export const actionTypes = {
  SET_CUSTOMER_NAME: "SET_CUSTOMER_NAME",
  SET_LOADING_PAGE: "SET_LOADING_PAGE",
  SET_ERROR_MESSAGE: "SET_ERROR_MESSAGE",
  SET_HEADER_VISIBLE: "SET_HEADER_VISIBLE",
  SET_TIMEZONE_ID: "SET_TIMEZONE_ID",
  SET_REAL_TIME_GROUP: "SET_REAL_TIME_GROUP",
  SET_REAL_TIME_GROUP_ID: "SET_REAL_TIME_GROUP_ID",
  SET_REAL_TIME_GROUP_NAME: "SET_REAL_TIME_GROUP_NAME",
  SET_REPORT_ASSET_ID:"SET_REPORT_ASSET_ID",
  SET_REPORT_CALENDAR_DATE:"SET_REPORT_CALENDAR_DATE",
  SET_REPORT_ASSET_NAME:"SET_REPORT_ASSET_NAME"
};
export function setTimezoneId(assetObj) {
  return { type: actionTypes.SET_TIMEZONE_ID, payload: assetObj };
}
export function setHeaderVisible(assetObj) {
  return { type: actionTypes.SET_HEADER_VISIBLE, payload: assetObj };
}

export function setCustomerName(assetObj) {
  return { type: actionTypes.SET_CUSTOMER_NAME, payload: assetObj };
}

export function setLoadingPage(assetObj) {
  return { type: actionTypes.SET_LOADING_PAGE, payload: assetObj };
}

export function setErrorMessage(assetObj) {
  return { type: actionTypes.SET_ERROR_MESSAGE, payload: assetObj };
}

export function setRealtimeGroup(assetObj) {
  return { type: actionTypes.SET_REAL_TIME_GROUP, payload: assetObj };
}

export function setRealtimeGroupId(assetObj) {
  return { type: actionTypes.SET_REAL_TIME_GROUP_ID, payload: assetObj };
}

export function setRealtimeGroupName(assetObj) {
  return { type: actionTypes.SET_REAL_TIME_GROUP_NAME, payload: assetObj };
}

export function setReportAssetId(assetObj) {
  return { type: actionTypes.SET_REPORT_ASSET_ID, payload: assetObj };
}
export function setReportCalendatDate(assetObj) {
  return { type: actionTypes.SET_REPORT_CALENDAR_DATE, payload: assetObj };
}
export function setReportAssetName(assetObj) {
  return { type: actionTypes.SET_REPORT_ASSET_NAME, payload: assetObj };
}